import AddressModal from "../modal/AddressModal";
import React from "react";
import LocationOffIcon from '@mui/icons-material/LocationOff';
import DefaultAddressCard from "./DefaultAddressCard";

function AddressComponent({addresses, setRefreshAddresses, setSelected, isCartItemUpdated, selected, defaultAddress, setDefaultAddress}){
    return (
        <div className="address-section">
            {addresses?.length > 0 ?  <h2>Address</h2> :  <h3>No Address Added <LocationOffIcon/></h3>}
            {addresses?.length > 0 && 
            defaultAddress && <>
                    <DefaultAddressCard item={defaultAddress} addresses={addresses} setSelected={setSelected} setRefreshAddresses={setRefreshAddresses} setDefaultAddress={setDefaultAddress} selected={selected}/>
                </>
            }
            <div className="common-btn address-btn">
                {/* <button style={{
                    background: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    width: "100%",
                }}
                    data-bs-toggle="modal"
                    data-bs-target="#addressModal">Add New Address <i className="fa-solid fa-plus"></i>
                </button> */}
                <button style={{
                    background: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    width: "100%",
                }}
                    data-bs-toggle="modal"
                    data-bs-target="#addressModal">Add New Address <i className="fa-solid fa-plus"></i>
                </button>
                <AddressModal setRefreshAddresses={setRefreshAddresses}/>
            </div>
        </div>
    )
}
export default AddressComponent